// Debug utilities for Nukeproof site
export const debugPreloadState = () => {
  console.group('Preload Debug Info');
  //console.log('Current pathname:', window.location.pathname);
  //console.log('Preloaded home data available:', !!window.preloadedHomeData);
  
  if (window.preloadedHomeData) {
    const missingKeys = [];
    ['homeData', 'novinkyData', 'pick4Data', 'headerData', 'footerData'].forEach(key => {
      if (!window.preloadedHomeData[key]) {
        missingKeys.push(key);
      } else {
        // Check if arrays are actually populated
        if (key === 'novinkyData' || key === 'pick4Data') {
          const data = window.preloadedHomeData[key];
          if (!Array.isArray(data) || data.length === 0) {
            missingKeys.push(`${key} (empty array)`);
          }
        }
        // Check if objects have data
        else if (key === 'homeData') {
          const data = window.preloadedHomeData[key];
          if (!data || !data.data || Object.keys(data.data).length === 0) {
            missingKeys.push(`${key} (empty object)`);
          }
        }
      }
    });
    
    console.log('Missing or empty preloaded data:', missingKeys.length ? missingKeys : 'None');
    
    // Log the API key status
    //console.log('Builder API key set:', !!window.builderAPIKey);
    
    //console.log('Preloaded data timestamp:', new Date().toISOString());
  }
  
  // Cache hit rate might not be available yet
  if (typeof window.__builderCacheHits !== 'undefined' && 
      typeof window.__builderCacheMisses !== 'undefined') {
    const hitRate = window.__builderCacheHits / 
      (window.__builderCacheHits + window.__builderCacheMisses) * 100;
    console.log('Builder cache hit rate:', isNaN(hitRate) ? '0%' : hitRate.toFixed(1) + '%');
  } else {
    console.log('Builder cache statistics not available');
  }
  
  console.groupEnd();
};

// Initialize tracking variables if they don't exist
if (typeof window !== 'undefined') {
  window.__builderCacheHits = window.__builderCacheHits || 0;
  window.__builderCacheMisses = window.__builderCacheMisses || 0;
}
